if (!customElements.get('product-inventory')) {
  class ProductInventory extends HTMLElement {
    constructor() {
      super();

      if (this.hidden) {
        this.initLazySection();
      } else {
        window.initLazyScript(this, this.initLazySection.bind(this));
      }
    }

    initLazySection() {
      this.inventoryNotice = this.querySelector('.js-inventory-notice');
      this.urgencyMessage = this.querySelector('.js-inventory-urgency');
      this.indicatorBar = this.querySelector('.js-inventory-indicator');
      this.variantInventory = this.getVariantInventory();

      const productInfo = this.closest('.product-info');
      const variantPicker = productInfo
        ? productInfo.querySelector('variant-picker')
        : null;

      if (variantPicker) {
        variantPicker.addEventListener(
          'on:variant:change',
          this.handleVariantChange.bind(this)
        );
      }

      this.updateInventory(
        parseInt(this.dataset.inventoryQuantity, 10),
        this.dataset.variantAvailable === 'true',
        this.dataset.inventoryPolicy,
        this.dataset.specialDelivery || ''
      );
    }

    getVariantInventory() {
      const dataEl = this.querySelector('[type="application/json"]');

      if (!dataEl) return [];

      try {
        return this.variantInventory || JSON.parse(dataEl.textContent);
      } catch (error) {
        console.warn(
          'Bar2Charge voorraadstatus: variantgegevens konden niet worden gelezen.',
          error
        );

        return [];
      }
    }

    handleVariantChange(evt) {
      if (evt.detail.variant) {
        const inventory = this.variantInventory.find(
          (variant) => variant.id === evt.detail.variant.id
        );

        if (!inventory) {
          this.updateInventory(0, false, '', '');
          this.hidden = true;
          return;
        }

        this.updateInventory(
          inventory.inventory_quantity,
          inventory.available,
          inventory.inventory_policy,
          inventory.special_delivery || ''
        );
      } else {
        this.updateInventory(0, false, '', '');
        this.hidden = true;
      }
    }

    updateInventory(
      count,
      available,
      inventoryPolicy,
      specialDelivery = ''
    ) {
      const deliveryText = String(specialDelivery || '').trim();

      const hasSpecialDelivery =
        deliveryText !== '' && available === true;

      if (
        count === 0 &&
        !available &&
        this.hidden &&
        !hasSpecialDelivery
      ) {
        return;
      }

      let inventoryLevel;

      if (hasSpecialDelivery) {
        inventoryLevel = 'special_delivery';
      } else if (count <= 0) {
        if (inventoryPolicy === 'continue') {
          inventoryLevel = 'backordered';
        } else if (available) {
          inventoryLevel = 'in_stock';
        } else {
          inventoryLevel = 'none';
        }
      } else if (
        count <= parseInt(this.dataset.thresholdVeryLow, 10)
      ) {
        inventoryLevel = 'very_low';
      } else if (
        count <= parseInt(this.dataset.thresholdLow, 10)
      ) {
        inventoryLevel = 'low';
      } else {
        inventoryLevel = 'normal';
      }

      const shouldShowStandardNotice =
        (
          this.dataset.showNotice === 'always' ||
          (
            this.dataset.showNotice === 'low' &&
            inventoryLevel.includes('low')
          )
        ) &&
        !(
          inventoryLevel === 'backordered' &&
          this.dataset.showNoStockBackordered === 'false'
        );

      if (hasSpecialDelivery || shouldShowStandardNotice) {
        this.hidden = false;

        if (hasSpecialDelivery) {
          this.setAttribute('data-inventory-level', 'normal');
          this.setAttribute(
            'data-special-delivery-active',
            'true'
          );
        } else {
          this.setAttribute(
            'data-inventory-level',
            inventoryLevel
          );

          this.removeAttribute(
            'data-special-delivery-active'
          );
        }

        if (hasSpecialDelivery) {
          this.inventoryNotice.innerText =
            'Beschikbaar met langere levertijd';
        } else if (inventoryLevel === 'backordered') {
          this.inventoryNotice.innerText = '';
        } else if (
          inventoryLevel !== 'in_stock' &&
          (
            this.dataset.showCount === 'always' ||
            (
              this.dataset.showCount === 'low' &&
              inventoryLevel.includes('low')
            )
          )
        ) {
          this.inventoryNotice.innerText =
            theme.strings.onlyXLeft.replace(
              '[quantity]',
              count
            );
        } else if (inventoryLevel === 'very_low') {
          this.inventoryNotice.innerText =
            theme.strings.veryLowStock;
        } else if (inventoryLevel === 'low') {
          this.inventoryNotice.innerText =
            theme.strings.lowStock;
        } else if (
          inventoryLevel === 'normal' ||
          inventoryLevel === 'in_stock'
        ) {
          this.inventoryNotice.innerText =
            theme.strings.inStock;
        } else if (inventoryLevel === 'none') {
          this.inventoryNotice.innerText =
            theme.strings.noStock;
        }

        if (this.urgencyMessage) {
          if (hasSpecialDelivery) {
            this.urgencyMessage.innerHTML = '';
          } else if (inventoryLevel === 'very_low') {
            this.urgencyMessage.innerHTML =
              this.dataset.textVeryLow;
          } else if (inventoryLevel === 'low') {
            this.urgencyMessage.innerHTML =
              this.dataset.textLow;
          } else if (inventoryLevel === 'backordered') {
            this.urgencyMessage.innerHTML =
              this.dataset.textNoStockBackordered;
          } else if (
            inventoryLevel === 'normal' ||
            inventoryLevel === 'in_stock'
          ) {
            this.urgencyMessage.innerHTML =
              this.dataset.textNormal;
          } else if (inventoryLevel === 'none') {
            this.urgencyMessage.innerHTML =
              this.dataset.textNoStock;
          }
        }

        if (this.indicatorBar) {
          this.indicatorBar.hidden = false;

          let newWidth;

          if (hasSpecialDelivery) {
            newWidth = 100;
          } else if (
            (
              count >= this.dataset.scale ||
              inventoryLevel === 'in_stock'
            ) &&
            inventoryLevel !== 'backordered'
          ) {
            newWidth = 100;
          } else {
            newWidth = (
              (
                100 /
                parseInt(this.dataset.scale, 10)
              ) *
              count
            ).toFixed(1);
          }

          this.indicatorBar.querySelector(
            'span'
          ).style.width = `${newWidth}%`;
        }
      } else {
        this.hidden = true;
      }
    }
  }

  customElements.define(
    'product-inventory',
    ProductInventory
  );
}